import React from 'react';

const DEFAULT_LOGO = 'https://customer-assets.emergentagent.com/job_a23407fa-1010-4440-8508-205dc6639444/artifacts/jd6qlo7n_logo-horizontal-transparent.png';
const ICON_ONLY = 'https://customer-assets.emergentagent.com/job_a23407fa-1010-4440-8508-205dc6639444/artifacts/eskyk5nt_icon-transparent-88680f9.png';

/**
 * Beyond Measure logo.
 * variant: 'horizontal' | 'icon' | 'short'
 * onDark: boolean — adjusts styling when placed on navy sidebar
 */
export default function BrandLogo({ variant = 'horizontal', onDark = false, className = '' }) {
    if (variant === 'icon') {
        return (
            <img
                src={ICON_ONLY}
                alt="Beyond Measure"
                className={`h-8 w-8 object-contain ${className}`}
                data-testid="brand-logo-icon"
            />
        );
    }
    if (variant === 'short') {
        return (
            <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo-short">
                <img src={ICON_ONLY} alt="" className="h-7 w-7 object-contain" />
                <span className={`font-display font-semibold tracking-tight text-[15px] ${onDark ? 'text-white' : 'text-[color:var(--bm-text)]'}`}>
                    BM <span className="text-[color:var(--bm-accent)]">HQ</span>
                </span>
            </div>
        );
    }
    return (
        <img
            src={DEFAULT_LOGO}
            alt="Beyond Measure"
            className={`h-9 object-contain ${className}`}
            data-testid="brand-logo-horizontal"
        />
    );
}
